import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Row, Col } from 'reactstrap';
import Body from '../Components/layout/Body';
import LearnMoreModal from '../Components/layout/LearnMoreModal';
import { getDetailsTableHTML, TestDriveInfoTable } from '../Components/layout/DisplayTestDriveInfo';
import { TABS, SUBTABS } from './ConstPaths';

const COMPARE_HELP = `
  <div>
    <p>Here you can specifically compare results from all the Test-drives you've done.  
    This may not be something you need in every case, but it’s here if you want it. 
    (Or just hit Continue to skip to the next step.) 
    </p>
    <p>To get a side-by-side comparison, click the Compare checkbox for each one you’re interested in, then choose Compare Selected Test-drives.   
    </p>
    <p>This step gives you a talking point to review what’s happened with the client and any other team members, 
    to see if any access methods in the Test-drives so far show promise for meeting the client’s needs. 
    </p>
  </div>
`;

const propTypes = {
  completedTestDrives: PropTypes.arrayOf(PropTypes.object),
};

const defaultProps = {
  completedTestDrives: []
};

//content sub-component with unique content for this page
function ReviewTabCompareContent(props) {
  const completedTestDrives = props.completedTestDrives;

  const [checkedState, setCheckedState] = useState(
    new Array(completedTestDrives.length).fill(false)
  );

  const handleOnChange = (position) => {
    const updatedCheckedState = checkedState.map((item, index) =>
      index === position ? !item : item
    );

    setCheckedState(updatedCheckedState);
  };  

  const td_path = TABS.TEST;

  //just in case we get to this view without any test-drives:
  if(completedTestDrives.length === 0){
    return(
      <>
      <p><strong>Note:</strong> There are no Test-drives shown here because you haven't completed any Test-drives yet.</p>
      <p>You can:</p>
      <ul>
        <li><Link to={td_path}>Start a Test-drive</Link>, complete one or more, then review the results here.</li>
      </ul>
      </>
    );
  }
  //the typical case where we do have Test-drives:
  return(
    <>
    {(completedTestDrives.length === 1) 
      ? <p><strong>Note: </strong>With only one Test-drive there's not really anything to compare. So feel free to just Continue.</p>
      : null
    }
    <h5><strong>All Test-drives</strong></h5>
    <TestDriveInfoTable
      testDrives={completedTestDrives}
      showDetailsCol={true}
      showCompareCol={true}
      checkedState={checkedState}
      onChange={handleOnChange}
    />
    <CompareSelectedButton testDrives={completedTestDrives} checkedState={checkedState}/>
    </>
  );
}

//Group of functions to handle opening and displaying the comparison table:
function CompareSelectedButton(props){
  const{
    testDrives,
    checkedState
  } = props;

  let tdsToCompare = [];
  let i=0;
  for (i=0; i<checkedState.length; i++){
    if (checkedState[i])
      tdsToCompare.push(testDrives[i]);
  }
  const detailsTableHTML = getDetailsTableHTML(tdsToCompare);

  return(
  <Row className="border-top aa-review-row">
    <Col>
    <LearnMoreModal 
      color="secondary"
      linkText="Compare Selected Test-drives"
      title="Compare Test-drives"
      content={detailsTableHTML}
    />
    </Col>
  </Row>
  ); 
}

//main component for this page
//basic pattern is to set up the pageData, define the unique content for the page (above),
//then render the page using <Body> component
function ReviewTabCompare(props) {
  const completedTestDrives = props.completedTestDrives;
  const pageData = {
    image: "",
    faIcon: "",
    pageSymbolClassName: "aa-section-symbol review",
    title: `Compare Your Test-drives`,
    subTitle: `This may help you see differences between Test-drives more clearly, particularly if you have data other than ratings, such as measurements from our in-app activities.`,
    learnMore: {linkText: "Learn More about comparing Test-drives",
                title: "Comparing Test-drives",
                content: COMPARE_HELP
                },
    nextRoute: SUBTABS.MAKE_CHOICES, //TODO used for now instead of an onContinue callback 
    sidebar: false,
    rightMargin: false
  }

  console.log("Rendering ReviewTabCompare");
  
  return(
    <>
    <Body page={pageData} 
      contentComponent={
        <ReviewTabCompareContent 
          completedTestDrives={completedTestDrives}
        />
      } 
    />
    </>
  );
}

ReviewTabCompare.propTypes = propTypes;
ReviewTabCompare.defaultProps = defaultProps;

export default ReviewTabCompare;